import posthog from 'posthog-js'

export default function initPosthog(): void {
  if (import.meta.env.DEV) return

  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return

  posthog.init(key, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    defaults: '2026-05-30'
  })
}

export function identifyPosthogUser(user: { id?: number; email?: string }): void {
  if (import.meta.env.DEV) return
  if (!import.meta.env.VITE_POSTHOG_KEY) return
  if (!user?.id) return

  posthog.identify(String(user.id), { email: user.email })
}
